import React, { useEffect, useState } from "react";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import "react-toastify/dist/ReactToastify.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "react-tabs/style/react-tabs.css";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
} from "@mui/material";
import {
  Person,
  ExitToApp,
} from "@mui/icons-material";

const Dashboard = () => {
  let Navigate = useNavigate();
  const location = useLocation();
  let _id = secureLocalStorage.getItem("n_id");
  let token = secureLocalStorage.getItem("n_token");
  let [get_user_profile, setget_user_profile] = useState([]);
  const [activeTab, setActiveTab] = useState(location.state || "dashboard");
  const [dashboardData, setDashboardData] = useState({
    totalCount: 0,
    pendingCount: 0,
    cancelledCount: 0,
    completedCount: 0,
    totalAmount: 0,
  });

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const items = { user_id: _id };

        const res = await axios.post(
          `${process.env.REACT_APP_API}website/get_user_profile`,
          items,
          {
            headers: {
              token: token,
            },
          },
        );

        if (res.data.result) {
          setget_user_profile(res.data.data);
        }
      } catch (error) {
        console.log("Error fetching profile", error);
      }
    };

    fetchUserProfile();
  }, [_id, token]);

  let Logout = () => {
    try {
      let item = {
        _id: _id,
      };
      axios
        .post(`${process.env.REACT_APP_API}website/logout`, item)
        .then((res) => {
          if (res.data.result) {
            localStorage.removeItem("ssstoken");
            secureLocalStorage.removeItem("n_id");
            secureLocalStorage.removeItem("n_token");
            secureLocalStorage.removeItem("n_mobile_no");
            secureLocalStorage.removeItem("n_otp");
            Navigate(`/`);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {}
  };

  const fetchDashboardData = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API}website/dashboard`,
        { user_id: _id },
      );

      if (res.data?.data) {
        setDashboardData(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  useEffect(() => {
    if (activeTab === "dashboard") {
      fetchDashboardData();
    }
  }, [activeTab]);

  return (
    <div>
      <Box sx={{ p: { xs: 2, sm: 3 } }}>
        {/* Welcome Card */}
        <Card
          elevation={0}
          sx={{
            mb: 4,
            backgroundColor: "#160015", // Dark purple background
            color: "#fee894", // Light yellow text
            border: "2px solid #fee894", // Light yellow border
          }}
        >
          <CardContent sx={{ p: { xs: 3, sm: 4 }, textAlign: "center" }}>
            <Person
              sx={{
                fontSize: { xs: 48, sm: 64 },
                mb: 2,
                opacity: 0.9,
                color: "#fee894", // Light yellow icon
              }}
            />
            <Typography
              variant="h4"
              component="h3"
              gutterBottom
              sx={{
                fontWeight: 600,
                fontSize: { xs: "1.75rem", sm: "2.125rem" },
                color: "#fee894", // Light yellow text
              }}
            >
              Welcome Back!
            </Typography>
            <Typography
              variant="h6"
              sx={{
                opacity: 0.9,
                mb: 2,
                fontSize: { xs: "1rem", sm: "1.25rem" },
                color: "#fee894", // Light yellow text
              }}
            >
              Hello,{" "}
              <strong style={{ color: "#fff" }}>
                {get_user_profile?.full_name}
              </strong>
            </Typography>
            <Button
              variant="outlined"
              startIcon={<ExitToApp />}
              onClick={Logout}
              sx={{
                color: "#fee894", // Light yellow text
                borderColor: "#fee894", // Light yellow border
                "&:hover": {
                  backgroundColor: "rgba(254, 232, 148, 0.1)", // Light yellow with opacity
                  borderColor: "#fee894",
                },
              }}
            >
              Logout
            </Button>
          </CardContent>
        </Card>

        {/* Stats Cards */}
        <Grid container spacing={3}>
          {/* Total Booking Amount */}
          <Grid item xs={12} sm={6} md={3} lg={2.4}>
            <Card
              elevation={0}
              sx={{
                height: "100%",
                backgroundColor: "#160015", // Dark purple background
                color: "#fee894", // Light yellow text
                border: "2px solid #fee894", // Light yellow border
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 8px 20px rgba(22, 0, 21, 0.3)",
                },
              }}
            >
              <CardContent sx={{ p: 3, textAlign: "center" }}>
                <Typography
                  variant="h4"
                  component="div"
                  sx={{
                    fontWeight: "bold",
                    mb: 1,
                    color: "#fee894", // Light yellow text
                  }}
                >
                  ₹{dashboardData?.totalAmount || 0}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    opacity: 0.9,
                    color: "#fee894", // Light yellow text
                  }}
                >
                  Total Order Amount
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Total Bookings */}
          <Grid item xs={12} sm={6} md={3} lg={2.4}>
            <Card
              elevation={0}
              sx={{
                height: "100%",
                backgroundColor: "#fee894", // Light yellow background
                color: "#160015", // Dark purple text
                border: "2px solid #160015", // Dark purple border
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 8px 20px rgba(254, 232, 148, 0.3)",
                },
              }}
            >
              <CardContent sx={{ p: 3, textAlign: "center" }}>
                <Typography
                  variant="h4"
                  component="div"
                  sx={{
                    fontWeight: "bold",
                    mb: 1,
                    color: "#160015", // Dark purple text
                  }}
                >
                  {dashboardData?.totalCount || 0}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    opacity: 0.9,
                    color: "#160015", // Dark purple text
                  }}
                >
                  Total Orders
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Pending Bookings */}
          <Grid item xs={12} sm={6} md={3} lg={2.4}>
            <Card
              elevation={0}
              sx={{
                height: "100%",
                backgroundColor: "#160015", // Dark purple background
                color: "#fee894", // Light yellow text
                border: "2px solid #fee894", // Light yellow border
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 8px 20px rgba(22, 0, 21, 0.3)",
                },
              }}
            >
              <CardContent sx={{ p: 3, textAlign: "center" }}>
                <Typography
                  variant="h4"
                  component="div"
                  sx={{
                    fontWeight: "bold",
                    mb: 1,
                    color: "#fee894", // Light yellow text
                  }}
                >
                  {dashboardData?.pendingCount || 0}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    opacity: 0.9,
                    color: "#fee894", // Light yellow text
                  }}
                >
                  Pending Orders
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Completed Bookings */}
          <Grid item xs={12} sm={6} md={3} lg={2.4}>
            <Card
              elevation={0}
              sx={{
                height: "100%",
                backgroundColor: "#fee894", // Light yellow background
                color: "#160015", // Dark purple text
                border: "2px solid #160015", // Dark purple border
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 8px 20px rgba(254, 232, 148, 0.3)",
                },
              }}
            >
              <CardContent sx={{ p: 3, textAlign: "center" }}>
                <Typography
                  variant="h4"
                  component="div"
                  sx={{
                    fontWeight: "bold",
                    mb: 1,
                    color: "#160015", // Dark purple text
                  }}
                >
                  {dashboardData?.completedCount || 0}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    opacity: 0.9,
                    color: "#160015", // Dark purple text
                  }}
                >
                  Completed Orders
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Cancelled Bookings */}
          <Grid item xs={12} sm={6} md={3} lg={2.4}>
            <Card
              elevation={0}
              sx={{
                height: "100%",
                backgroundColor: "#160015", // Dark purple background
                color: "#fee894", // Light yellow text
                border: "2px solid #fee894", // Light yellow border
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 8px 20px rgba(22, 0, 21, 0.3)",
                },
              }}
            >
              <CardContent sx={{ p: 3, textAlign: "center" }}>
                <Typography
                  variant="h4"
                  component="div"
                  sx={{
                    fontWeight: "bold",
                    mb: 1,
                    color: "#fee894", // Light yellow text
                  }}
                >
                  {dashboardData?.cancelledCount || 0}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    opacity: 0.9,
                    color: "#fee894", // Light yellow text
                  }}
                >
                  Cancelled Orders
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default Dashboard;
